import React, { useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import '../../css/static-pages-css/WinnerAnnouncement.css';
import celebrationImg from '../../img/static-page-img/celebration-img.png';
import ThemeChangeIcon from "../themeChangeComponent";


const Confetti = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    const containerEl = document.createElement('div');
    containerEl.classList.add('confetti-container');
    el.appendChild(containerEl);

    const confettiColors = ['#EF2964', '#00C09D', '#2D87B0', '#48485E', '#EFFF1D'];
    const confettiAnimations = ['slow', 'medium', 'fast'];

    const interval = setInterval(() => {
      const confettiEl = document.createElement('div');
      const size = Math.floor(Math.random() * 3) + 7;
      const color = confettiColors[Math.floor(Math.random() * confettiColors.length)];
      const animation = confettiAnimations[Math.floor(Math.random() * confettiAnimations.length)];
      const left = Math.floor(Math.random() * window.innerWidth);

      confettiEl.classList.add('confetti', `confetti--animation-${animation}`);
      confettiEl.style.left = `${left}px`;
      confettiEl.style.width = `${size}px`;
      confettiEl.style.height = `${size}px`;
      confettiEl.style.backgroundColor = color;

      containerEl.appendChild(confettiEl);

      setTimeout(() => {
        confettiEl.remove();
      }, 3000);
    }, 25);

    return () => {
      clearInterval(interval);
      containerEl.remove();
    };
  }, []);

  return <div className="js-container" ref={containerRef}></div>;
};


const WinnerAnnouncement = () => {
  return (
    <div class="row w-100 g-0">
      {/* theme change icon */}
      <ThemeChangeIcon />

      <div class="col-12 d-none d-lg-block col-lg-5 bg-image vh-100 position-fixed">
        <div className="mask text-light d-flex flex-column p-5 vh-100 w-100">
          <div class="logo-div float-start">
            <Link className="navbar-brand company-logo company-logo-base" to="/"></Link>
          </div>
          <div class="mt-auto text-start">
            <h3 class="fw-bold text-uppercase">welcome to abbott</h3>
            <h3 class="fw-bold text-uppercase display-6 text-color-primary pb-5">
              product verification
            </h3>

            <span class="pt-5 text-uppercase">
              *This is a mockup page showcasing digital serialization v2.8
            </span>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-7 offset-lg-5 d-flex flex-column vh-100">
        <div
          class="collapse mobile-nav-bar-menu-show"
          id="navbarToggleExternalContent"
          data-bs-theme="dark"
        >
          <div class="bg-dark p-4 text-start">
            <span class="text-body-secondary text-uppercase">
              *This is a mockup page showcasing digital serialization v2.8
            </span>
          </div>
        </div>

        <nav class="navbar navbar-dark bg-dark py-3 d-block d-lg-none">
          <div class="container-fluid px-4">
            <Link class="navbar-brand company-logo company-logo-base-mobile" to="/"></Link>
            <button
              class="navbar-toggler border-0 ms-auto px-0"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarToggleExternalContent"
              aria-controls="navbarToggleExternalContent"
              aria-expanded="false"
              aria-label="Toggle navigation"

              style={{visibility: 'hidden'}}
            >
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>
        </nav>

        <div class="d-block d-lg-none top-bg-img-container">
          <div class="top-bg-img">
            <div class="top-bg-img-overlay">
              <div class="pt-5 px-4 text-start">
                <h3 class="fw-bold text-uppercase text-color-white">
                  welcome to abbott
                </h3>
                <h3 class="fw-bold text-uppercase display-6 text-color-primary">
                  product verification
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-lg-4 pt-4 w-100 d-flex align-items-center justify-content-center">
          <Confetti />
          <div className="party-popup">
            <img src={celebrationImg} alt="Celebration" />
            <h1 className="popup-title">🎉 You’ve Been Selected as a Winner! 🎉</h1>
            <p className="popup-desc">
              You’re one of our lucky winners!<br />
              Visit your nearest participating store to collect your prize.
            </p>
            <p className="popup-note">
              Please show this coupon number and claim your prize.<br />
              <span className="fw-bold">Coupon Number: 123456789</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WinnerAnnouncement;